let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJhuA")).then(() => parcelRequire('hfU8q'));